const ratings = {
  1: 'ONE_STAR',
  2: 'TWO_STARS',
  3: 'THREE_STARS',
  4: 'FOUR_STARS',
  5: 'FIVE_STARS'
};

const halfRatings = {
  ONE_STAR: 'ONE_STAR_AND_HALF',
  TWO_STARS: 'TWO_STARS_AND_HALF',
  THREE_STARS: 'THREE_STARS_AND_HALF',
  FOUR_STARS: 'FOUR_STARS_AND_HALF',
  FIVE_STARS: 'FIVE_STARS_AND_HALF'
};

export type RatingType = 'diamond' | 'star' | 'catalunya';

export type RatingValueAndType = { value: number; type: RatingType; color: string };

function getRatingsArray(values: number[]): string[] {
  const ratingArray: string[] = [];
  values.forEach((v, i) => {
    ratingArray.push(ratings[v]);
    if (i + 1 < values.length && v + 1 === values[i + 1]) {
      ratingArray.push(halfRatings[ratings[v]]);
    }
  });

  // Handle FIVE_STARS_AND_HALF
  const last2Elements = values.slice(-2);
  if (last2Elements.length === 2 && last2Elements[0] === 4 && last2Elements[1] === 5) {
    ratingArray.push(halfRatings.FIVE_STARS);
  }
  return ratingArray;
}

/**
 * for filters - based on the min and max ratings, build an array of ratings to apply
 */
export function buildRatingArray(filter: { includeUnratedVenues: boolean; values: Array<number> }): string[] {
  let ratingArray: string[] = [];

  if (filter.includeUnratedVenues) {
    ratingArray.push('UNRATED');
  }

  ratingArray = ratingArray.concat(
    getRatingsArray(filter.values?.length > 0 ? filter.values.sort() : Object.keys(ratings).map(k => Number(k)))
  );
  return ratingArray;
}

// preferred rating enum returned from API -> value and type to show on UI
export const getRatingNumberAndType = (rating: string): RatingValueAndType => {
  let ratingNumber = 0;
  if (rating.indexOf('ONE') !== -1) {
    ratingNumber = 1;
  } else if (rating.indexOf('TWO') !== -1) {
    ratingNumber = 2;
  } else if (rating.indexOf('THREE') !== -1) {
    ratingNumber = 3;
  } else if (rating.indexOf('FOUR') !== -1) {
    ratingNumber = 4;
  } else if (rating.indexOf('FIVE') !== -1) {
    ratingNumber = 5;
  }

  if (rating.indexOf('HALF') !== -1) {
    ratingNumber += 0.5;
  }

  if (rating === 'CATALUNYA_FOUR_STAR_SUPERIOR') {
    ratingNumber = 4.5;
  }

  if (rating === 'CATALUNYA_LUXE') {
    ratingNumber = 5.5;
  }

  let type;
  const color = 'fill-diamond-icon';
  if (rating.indexOf('CATALUNYA') !== -1) {
    type = 'catalunya';
  } else if (rating.indexOf('STAR') !== -1) {
    type = 'star';
  } else if (rating.indexOf('DIAMOND') !== -1) {
    type = 'diamond';
  }

  return {
    value: ratingNumber,
    type,
    color
  };
};
